import { IconProps } from "./types";
import React from "react";

export const CircleIcon = ({
  className,
  fill = "currentColor",
  width = 24,
  height = 24,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox="0 0 20 20"
    className={className}
    style={style}
    fill={fill}
  >
    <circle cx="12" cy="12" r="10" fill={fill} />
  </svg>
);
